import React, {useEffect, useState} from 'react';
import ProductImageSmall from "../product-upload/product-image-small";
import _ from "lodash";
import {getAllPODProducts, searchProducts} from "../../services/product-data-service";
import {PRODUCT_DETAIL_KEY, SAVE_POD_TIME_DELAY, SEARCH_PRODUCTS_TIME_DELAY} from "../../constants/pod.constant";
import {TrashIcon} from "@heroicons/react/24/solid";

const ProductFilters = ({
                            podDetail,
                            filterCriteria,
                            setFilterCriteria,
                            searchProductsList,
                            hideColorsAndSizes,
                            clearFilterCriteria
                        }) => {
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [colors, setColors] = useState(null);
    const [sizes, setSizes] = useState(null);
    let [changesCount, setChangesCount] = useState(0);
    const [initialStep, setInitialStep] = useState(true);

    useEffect(() => {
        init();
    }, [initialStep]);

    const init = () => {
        if (_.isEmpty(filterCriteria)) {
            return;
        }

        let existingProductType;
        let existingCategory;
        let existingParent;

        if (filterCriteria?.productType) {
            const productTypesMap = _.keyBy(podDetail?.productTypesList, 'name');
            existingProductType = productTypesMap[filterCriteria?.productType];
            setSelectedProductType(existingProductType);
        }

        if (filterCriteria?.category) {
            const categoriesMap = _.keyBy(existingProductType?.categories, 'name');
            existingCategory = categoriesMap[filterCriteria?.category];

            if (existingCategory) {
                setSelectedCategory(existingCategory);
                setColorsAndSizes(existingCategory?.colors, existingCategory?.sizes);
            }
        }

        if (filterCriteria?.parent) {
            const parentProductsMap = _.keyBy(existingCategory?.parentProducts, 'name');
            existingParent = parentProductsMap[filterCriteria?.parent];

            if (existingParent) {
                setSelectedParentProduct(existingParent);
                setColorsAndSizes(existingParent.colors, existingParent.sizes);
            }
        }
    }

    const handleFilterChanges = (event) => {
        const {name, value} = event.target;

        if (name === PRODUCT_DETAIL_KEY.PRODUCT_TYPE) {
            const productTypesMap = _.keyBy(podDetail?.productTypesList, 'name');
            const tempSelectedProductType = productTypesMap[value];

            setSelectedProductType(tempSelectedProductType);
            clearSelectedCategory();
        } else if (name === PRODUCT_DETAIL_KEY.CATEGORY) {
            const categoriesMap = _.keyBy(selectedProductType?.categories, 'name');
            const tempSelectedCategory = categoriesMap[value];

            setSelectedCategory(tempSelectedCategory);
            setColorsAndSizes(tempSelectedCategory.colors, tempSelectedCategory.sizes);
            clearSelectedParentProduct();
        } else if (name === PRODUCT_DETAIL_KEY.PARENT) {
            const parentProductsMap = _.keyBy(selectedCategory?.parentProducts, 'name');
            const tempSelectedParentProduct = parentProductsMap[value];

            setSelectedParentProduct(tempSelectedParentProduct);
            setColorsAndSizes(tempSelectedParentProduct.colors, tempSelectedParentProduct.sizes);
        } else if (name === PRODUCT_DETAIL_KEY.COLOR) {
            const colorsMap = _.keyBy(colors, 'name');
            setSelectedColor(colorsMap[value]);
        } else if (name === PRODUCT_DETAIL_KEY.SIZE) {
            const sizesMap = _.keyBy(sizes, 'name');
            setSelectedSize(sizesMap[value]);
        }

        prepareFilterCriteria(name, value);
    }

    const clearSelectedProductType = () => {
        setSelectedProductType(null);
        clearSelectedCategory();
    }

    const clearSelectedCategory = () => {
        setSelectedCategory(null);
        clearSelectedParentProduct();
    }

    const clearSelectedParentProduct = () => {
        setSelectedParentProduct(null);
    }

    const clearSelectedColorsAndSizes = () => {
        setSelectedColor(null);
        setSelectedSize(null);
    }

    const clearColorsAndSizes = () => {
        setColors(null);
        setSizes(null);
    }

    const setColorsAndSizes = (colors, sizes) => {
        setColors(colors);
        setSizes(sizes);
    }

    const prepareFilterCriteria = (name, value) => {
        const existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria[name] = value;
        setFilterCriteria(existingFilterCriteria);
    }

    const handleClearFilters = () => {
        setSelectedProductType(null);
        setSelectedCategory(null);
        setSelectedParentProduct(null);
        setSelectedColor(null);
        setSelectedSize(null);

        clearColorsAndSizes();

        if (clearFilterCriteria) {
            clearFilterCriteria();
        } else {
            setFilterCriteria({
                productType: '',
                category: '',
                parent: '',
                color: '',
                size: '',
            });
        }

    }

    useEffect(() => {
        incrementChangesCount();
    }, [filterCriteria]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    searchProductsList();
                }

            }, SEARCH_PRODUCTS_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    return (
        <>

            <div className="flex justify-start">
                <div className="field-group-container">

                    <div className="field-container">
                        <div className="field-label">
                            Product Type <span
                            className="pl-1 text-gray-400">({podDetail?.productTypesList?.length})</span>
                        </div>
                        <select
                            className="input-field"
                            id="productType"
                            name="productType"
                            value={filterCriteria?.productType}
                            onChange={handleFilterChanges}>
                            <option value="">All Product Types</option>
                            {podDetail?.productTypesList?.map((option, index) => (
                                <option key={index}
                                        value={option?.name}>{option?.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <div className="field-label">
                            Category
                            {selectedProductType &&
                                <span
                                    className="pl-1 text-gray-400">({selectedProductType?.categories?.length})</span>
                            }
                        </div>
                        <select
                            className="input-field"
                            id="category"
                            name="category"
                            value={filterCriteria?.category}
                            onChange={handleFilterChanges}>
                            <option value="">All Categories</option>
                            {selectedProductType?.categories?.map((option, index) => (
                                <option key={index}
                                        value={option?.name}>{option?.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <div className="field-label">
                            Parent Product
                            {selectedCategory &&
                                <span
                                    className="pl-1 text-gray-400">({selectedCategory?.parentProducts?.length})</span>
                            }
                        </div>
                        <select
                            className="input-field"
                            id="parent"
                            name="parent"
                            value={filterCriteria?.parent}
                            onChange={handleFilterChanges}>
                            <option value="">All Parent Products</option>
                            {selectedCategory?.parentProducts?.map((option, index) => (
                                <option key={index}
                                        value={option?.name}>{option?.name}</option>
                            ))}
                        </select>
                    </div>

                    {!hideColorsAndSizes && (selectedParentProduct || selectedCategory) &&

                        <>
                            <div className="field-container">
                                <div className="field-label">
                                    Colors
                                    {colors && <span className="pl-1 text-gray-400">({colors?.length})</span>}
                                </div>
                                <select
                                    className="input-field"
                                    id="color"
                                    name="color"
                                    value={filterCriteria?.color}
                                    onChange={handleFilterChanges}>
                                    <option value="">All Colors</option>
                                    {colors?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="field-container">
                                <div className="field-label">
                                    Size
                                    {sizes && <span className="pl-1 text-gray-400">({sizes?.length})</span>}
                                </div>
                                <select
                                    className="input-field"
                                    id="size"
                                    name="size"
                                    value={filterCriteria?.size}
                                    onChange={handleFilterChanges}>
                                    <option value="">All Sizes</option>
                                    {sizes?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        </>

                    }

                    <button
                        onClick={() => handleClearFilters()}
                        className="button-small-link mt-7">
                        Clear Filters
                    </button>

                </div>
            </div>

        </>
    )
}

export default ProductFilters
